
import type { GradeData } from "../models";

export default {
  props: {
    grade: Object as () => GradeData, // Thanks @mmitchellgarcia on Medium
  },
  methods: {
    formatGrade(grade: number, maxPoints: number) {
      return Math.floor(grade / maxPoints * 1000 + .5) / 10;
    }
  }
};
